import React, { useState, useEffect } from "react";
import "./Blog.css";
import Post from "./BlogComponents/Post";
import useDocumentMeta from "../hooks/useDocumentMeta";

const Blog = () => {
  const [BlogJSON, setData] = useState([]);

  const getData = () => {
    fetch('https://ekselowe.pl/api/getposts.php'
      , {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        setData(myJson);

      }).catch(error => {
        setData({
          "post1": {
            "title": "Server Error",
            "text": "{ error }",
          }
        })
        console.log(error)
      });
  }
  useEffect(() => {
    getData()
  }, [])

  useDocumentMeta({
    title: "Aktualności",
    description: "Najnowsze projekty, wdrożenia i aktualności Ekselowe.pl — narzędzia Excel, automatyzacje i aplikacje webowe dla biznesu.",
  });

  return (
    <div className="blog-big-panel" id="blog-big-panelid" >
      <h1 className="blog-page-title">Aktualności</h1>
      <div className="blog-big-container">
        {
          Object.keys(BlogJSON).reverse().map((key) => (
            <Post
              key={key}
              title={BlogJSON[key].title}
              text={BlogJSON[key].text}
              image={BlogJSON[key].image}
              id={key}
            />
          ))
        }
      </div>
    </div>
  );
};

export default Blog;
